import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  FormLayout, TextField, Toast, Button, Modal, Icon, 
} from "@shopify/polaris";

import {
  ViewIcon, EyeCheckMarkIcon,
} from '@shopify/polaris-icons';
import {reqPostAppAccountAction} from '../../../../../api';
import { API_DOMAIN } from '../../../../../utils/constants';
import intl from '../../../../../i18n/intl';
import utils from '../../../../../utils/utils';
import NeedUpdateInfo from '../../../../../components/NeedUpdateInfo';
import './index.css';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocusEmail: false,

      AccountEmail: '',
      ResetPasswordActive: false,
      hidePassword: true,
      hideNewPassword: true,
      hideConfirmPassword: true,
      oldPasswordError: '',
      newPasswordError: '',
      confirmPasswordError: '',
      resetPasswordLoading: false,

      ChangeAccountEmailActive: false,
      sendCodeLoading: false,
      verifyLoading: false,
      NewEmailAddress: '',
      newEmailAddressError: '',
      VerifyCode: '',
      verifyCodeError: '',
      isEffective: true,
      //弹窗
      showToast: false,  //弹窗显示
      showToastText: '',  //弹窗文字
      showToastIserror: false, //弹窗是否错误
      secondsLeft: 0,
      isSending: false,
    };
    // 计时器
    this.timer = null;
  }
  componentWillUnmount = () => {
    clearInterval(this.timer);
  }
  
  //提示弹窗
  toggleToast = (showToastText, showToastIserror = false) => {
    if (showToastText === '') {
      this.setState({
        showToast: false
      })
    }else {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  }
  };


  // 重置密码 / 更换登录邮箱 弹窗控制
  handleAccountModal = (type, bool) => {
    if (type === 'password') {
      if (this.timer) {
        clearInterval(this.timer);
        this.setState({ isSending: false });
      }
      this.setState({
        ResetPasswordActive: bool,
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: '',
        hidePassword: true,
        hideNewPassword: true,
        hideConfirmPassword: true,
        oldPasswordError: '',
        newPasswordError: '',
        confirmPasswordError: '',
        VerifyCode: '',
        verifyCodeError: '',
        timer:null
      });
    }
  }

  // 密码显示与隐藏
  handleDisplaySwitch = (field) => {
    switch (field) {
      case 'hidePassword':
        this.setState(({ hidePassword }) => ({ hidePassword: !hidePassword }));
        break;
      case 'hideNewPassword':
        this.setState(({ hideNewPassword }) => ({ hideNewPassword: !hideNewPassword }));
        break;
      case 'hideConfirmPassword':
        this.setState(({ hideConfirmPassword }) => ({ hideConfirmPassword: !hideConfirmPassword }));
        break;
      default:
    }
  }

  // email 格式验证
  checkInputEmail(email) {
    let errorMsg = '';
    let bool = false;
    if (email === undefined || email === '') {
      errorMsg = intl.get('Please enter new account email');
    }

    if (errorMsg === '') {
      let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      bool = reg.test(email);
      errorMsg = bool ? '' : intl.get('Invalid email address');
    }
    this.setState({ newEmailAddressError: errorMsg });
    return bool;
  }

  // password 密码校验
  checkInputPassword(password) {
    let errorMsg = '';
    let bool = true;
    if (password === undefined || password === '') {
      bool = false;
      errorMsg = intl.get('Please enter a new password.');
    }

    // 注册时校验密码格式
    if (errorMsg === '') {
      // 1.The password must be 8 - 24 characters long
      // 2.The password contains at least 1 uppercase letter, 1 lowercase letter and 1 number

      if (password.length < 8 || password.length > 24) {
        errorMsg = intl.get('Password must be at least 8 characters long, including uppercase and lowercase letters, and numbers.');
        bool = false;
      } else {
        let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,24}$/;
        bool = reg.test(password);
        errorMsg = bool ? '' : intl.get('Password must be at least 8 characters long, including uppercase and lowercase letters, and numbers.');
      }
    }

    this.setState({ newPasswordError: errorMsg });
    return bool;
  }

  // 两次密码校验
  checkInputConfirmPassword(password) {
    let errorMsg = '';
    let bool = false;
    if (password === '') {
      errorMsg = intl.get('The password cannot be empty');
    }

    if (errorMsg === '') {
      if (password === this.state.NewPassword) {
        bool = true;
      }
      errorMsg = bool ? '' : intl.get("Confirm password doesn't match");
    }
    this.setState({ confirmPasswordError: errorMsg });
    return bool;
  }

  // 重置密码
  ResetPasswordSave = async () => {
    let isAllow = true;
    if (this.state.NewPassword === '' || this.state.NewPassword === undefined) {
      this.setState({ newPasswordError: intl.get('Please enter a new password.') });
      isAllow = false;
    }
    if (this.state.VerifyCode === '' || this.state.VerifyCode === undefined) {
      this.setState({ verifyCodeError: intl.get('Please enter the verification code.') });
      isAllow = false;
    }
    if (!this.checkInputPassword(this.state.NewPassword)) {
      isAllow = false;
    }
    if (!isAllow) {
      return false;
    }

    const params = {
      t: 'password',
      new: this.state.NewPassword,
      code: this.state.VerifyCode
    };

    this.setState({ resetPasswordLoading: true });
    const response = await reqPostAppAccountAction(params)
    this.setState({ resetPasswordLoading: false });

    if (response.code === '200') {
      this.toggleToast('Password updated', false);
      // 重新登录
      // this.logoutToLogin();

      // 关闭弹窗，清除定时器
      this.handleAccountModal('password', false);
      if (this.timer) {
        clearInterval(this.timer);
      }
    } else {
      if (response.code === '502') {
        this.setState({ verifyCodeError: response.msg });
        return false;
      }

      this.toggleToast(response.msg);
    }
  }

  /**
   * 登出重新登录
   * 
   * 说明：如果是Shopify内嵌模式，跳转到站外
   * 
   * @returns
   */
  logoutToLogin = () => {
    const shopify = window.shopify;
    if (shopify) {
      try {
        // 获取当前域名
        let localHost = '';

        if (API_DOMAIN === 'https://api.dropshipman.com') {
          localHost = 'https://app.dropshipman.com';
        }

        if (API_DOMAIN === 'https://test-api.dropshipman.com') {
          localHost = 'https://test-app.dropshipman.com';
        }

        if (localHost) {
          const w = window.open('about:blank');
          w.location.href = localHost + '/login';
        }

      } catch (error) {
       
      }

    } else {
      utils.removeStore('S_AUTHORIZATION');
      utils.setStore('S_SHOP_DOMAIN', '');
      utils.setStore('S_USER_TOKEN', '');
      window.location.href = '/login';
    }

    return true;
  }

  // 60秒计时器
  startCountdown = () => {
    
    this.timer = setInterval(() => {
      if (this.state.secondsLeft > 0) {
        this.setState(prevState => ({ secondsLeft: prevState.secondsLeft - 1 }));
      } else {
        clearInterval(this.timer);
        this.setState({ isSending: false });
      }
    }, 1000);
  };

  // 发送邮箱验证码
  sendVerificationCode = async (type) => {
    
    if (type === 'email') {
      if (!this.checkInputEmail(this.state.NewEmailAddress)) {
        return false;
      }
    }
    let isAllow = true;
    if (type === 'password') {
      if (this.state.NewPassword === '' || this.state.NewPassword === undefined) {
        this.setState({ newPasswordError: intl.get('Please enter a new password.') });
        isAllow = false;
      }
      if (!this.checkInputPassword(this.state.NewPassword)) {
        isAllow = false;
      }
    }
    if (!isAllow) {
      return false;
    }

    const params = {
      t: 'code',
      email: this.state.NewEmailAddress,
      action: type
    };
    this.setState({ sendCodeLoading: true });
    const response = await reqPostAppAccountAction(params)
    this.setState({ sendCodeLoading: false });

    if (response.code === '200') {
      this.toggleToast('Code sent');
      setTimeout(() => {
        this.toggleToast('');
      }, 2000);
      // 启动计时器
      this.setState({
        isSending: true,
        secondsLeft: 60
      }, () => {
        this.startCountdown();
      })
    } else {
      if (response.code === '503') {
        this.setState({ newEmailAddressError: response.msg });
        return false;
      }
      if (response.code === '505') {
        this.setState({ verifyCodeError: response.msg });
        return false;
      }
      this.toggleToast(response.msg);
    }
  }

  // 验证邮箱验证码
  VerifyCodeRequest = async () => {
    let isAllow = true;
    if (!this.checkInputEmail(this.state.NewEmailAddress)) {
      isAllow = false;
    }

    if (this.state.VerifyCode === '') {
      isAllow = false;
      this.setState({ verifyCodeError: intl.get('Verify code cannot be empty.') });
    }

    if (!isAllow) {
      return false;
    }

    const params = {
      t: 'change',
      email: this.state.NewEmailAddress,
      code: this.state.VerifyCode
    };
    this.setState({ verifyLoading: true });
    const response = await reqPostAppAccountAction(params)
    this.setState({ verifyLoading: false });

    if (response.code === '200') {
      this.toggleToast('Email updated', false);
      this.logoutToLogin();
    } else {
      if (response.code === '502') {
        this.setState({ verifyCodeError: response.msg });
        return false;
      }
      this.toggleToast(response.msg);
    }
  }

  // checkbox change
  handleCheckboxChange = (value, id) => {
    this.setState({
      [id]: value
    });
  }

  // input change
  handleInputChange = (value, id) => {
    if (id=== 'AccountName') {
      this.setState({ accountNameError: '' });
    }
    this.setState({
      [id]: value,
    }, () => {
      setTimeout(() => {
        switch (id) {
          case 'NewPassword':
            // this.checkInputPassword(value);
            this.setState({ newPasswordError: '' });
            break;
          case 'ConfirmPassword':
            if (value.length >= 2) {
              this.checkInputConfirmPassword(value);
            }
            break;
          case 'OldPassword':
            if (value !== '') {
              this.setState({ oldPasswordError: '' });
            }
            break;
          case 'NewEmailAddress':
            // this.checkInputEmail(value);
            this.setState({ newEmailAddressError: '' });
            break;
          case 'VerifyCode':
            if (value !== '') {
              this.setState({ verifyCodeError: '' });
            }
            break;
          default:
        }
      }, 100);
    });
    if (id === 'AccountName') {
      this.setState({
        disabledSaveData: false
      })
    }
  }

  // 失焦校验重置密码
  checkNewPasswordByBlur()
  {
    this.checkInputPassword(this.state.NewPassword);
  }
  
// 回调关闭弹窗
callBackHandleAuthModalClosed = () => {
    this.setState({
      authorizeModalActive: false,
      needSetPasswordActive: false
    });
  };

  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} duration={2000} onDismiss={() => this.toggleToast('')} error={this.state.showToastIserror} /> : null;
    const {
      AccountEmail,
      ResetPasswordActive, ChangeAccountEmailActive, hideNewPassword, NewPassword,
      newPasswordError, resetPasswordLoading, NewEmailAddress, newEmailAddressError, VerifyCode, verifyCodeError, sendCodeLoading,
      verifyLoading,  needSetPasswordActive, isSending, secondsLeft,
    } = this.state;
    let timerText = '';
    if (isSending) {
      timerText = '(' + secondsLeft + ')';
    }

    // 重置密码弹窗
    const ResetPasswordModal = (
      <Modal
        open={ResetPasswordActive}
        onClose={() => this.handleAccountModal('password', false)}
        title={intl.get("Reset password")}
        primaryAction={{
          content: intl.get('Apply'),
          onAction: this.ResetPasswordSave,
          loading: resetPasswordLoading
        }}
        secondaryActions={[
          {
            content: intl.get('Cancel'),
            onAction: () => this.handleAccountModal('password', false),
          },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <div>
             {intl.get("Please enter a new password and get a verification code from email")}  <span style={{ color: 'blue' }}>{AccountEmail}</span>.
            </div>

            <div className='Reset_Password_Input'>
              <TextField
                id="NewPassword"
                type={hideNewPassword ? "password" : "text"}
                label={intl.get("New Password")}
                value={NewPassword}
                onChange={this.handleInputChange}
                onBlur={() => this.checkNewPasswordByBlur()}
                minLength={8}
                maxLength={24}
                error={newPasswordError}
                suffix={
                  <div className="reset_password" onClick={() => this.handleDisplaySwitch('hideNewPassword')}>
                    <Icon source={hideNewPassword ? ViewIcon : EyeCheckMarkIcon} />
                  </div>
                }
              />
            </div>

            <TextField
              id="VerifyCode"
              label={intl.get("Verification code")}
              value={VerifyCode}
              onChange={this.handleInputChange}
              maxLength={10}
              error={verifyCodeError}
              connectedRight={
                <Button
                  // variant='primary'
                  onClick={() => this.sendVerificationCode('password')}
                  loading={sendCodeLoading}
                  disabled={isSending}
                >
                  {intl.get("send Code") + timerText}
                </Button>
              }
            />
          </FormLayout>
        </Modal.Section>
      </Modal>
    );


    // 更新登录账号email弹窗
    const ChangeAccountEmailModal = (
      <Modal
        open={ChangeAccountEmailActive}
        onClose={() => this.handleAccountModal('change_account', false)}
        title={intl.get("Change account email")}
        primaryAction={{
          content: intl.get('Verify'),
          onAction: this.VerifyCodeRequest,
          loading: verifyLoading,
          disabled: (VerifyCode === '') ? true : false
        }}
        secondaryActions={[
          {
            content: intl.get('Cancel'),
            onAction: () => this.handleAccountModal('change_account', false),
          },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <TextField
              id="NewEmailAddress"
              type="email"
              label={intl.get("New email address")}
              onChange={this.handleInputChange}
              value={NewEmailAddress}
              error={newEmailAddressError}
              connectedRight={
                <Button
                  // variant='primary'
                  onClick={() => this.sendVerificationCode('email')}
                  loading={sendCodeLoading}
                  disabled={isSending}
                >
                  {intl.get("send Code") + timerText}
                </Button>
              }
            />
            <div>
              {intl.get("We will send a verification code to the new email address. Please copy it and enter below to verify your mailbox.")}
            </div>
            <TextField
              id="VerifyCode"
              label={intl.get("Verify code")}
              value={VerifyCode}
              onChange={this.handleInputChange}
              maxLength={10}
              helpText={intl.get('Get code from verification email and enter here to get verified')}
              error={verifyCodeError}
            />
          </FormLayout>
        </Modal.Section>
      </Modal>
    )
    return (
      <div>
        <Button variant='plain' removeUnderline onClick={() => this.handleAccountModal('password', true)}>Reset</Button>
          {toastMarkup}
          {/* 账户重置密码弹窗 */}
          {ResetPasswordModal}
          {/* 账户更换登录邮箱弹窗 */}
          {ChangeAccountEmailModal}
          {/* 默认平台生成的账户提醒修改默认密码 */}
          <NeedUpdateInfo
            show={needSetPasswordActive}
            email={AccountEmail}
            onClose={this.callBackHandleAuthModalClosed}
          />
      </div>
    );

  }
}

export default connect()(Index);